import { ControlBar, Container, SeekBar, SeekBarLabel, VolumeControlButton } from 'bitmovin-player-ui';
import { createSeekBar } from '../seekbar';
export function createAudioControlBar(npoPlayer) {
    const seekBar = new SeekBar({ label: new SeekBarLabel() });
    npoPlayer.uiComponents.seekBar = seekBar;
    const controlBar = new ControlBar({
        components: [
            createSeekBar(npoPlayer),
            new Container({
                components: [
                    new VolumeControlButton({
                        vertical: true
                    })
                ],
                cssClasses: ['controlbar-bottom']
            })
        ],
        cssClasses: ['ui-controlbar-bottom']
    });
    npoPlayer.uiComponents.controlBar = controlBar;
    return controlBar;
}
